import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import ShopHeader from '@/repositories/data/content/ShopHeader';

export default class ShopHeaderRepository extends BaseCrudRepository<number, ShopHeader, ShopHeader> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/shop-header/');
    }
}
